import store from 'store2'
import CryptoJS from 'crypto-js'

import { LAST_PRODUCT_STORE } from '../constants/global'

const SECRET_KEY = 'F1qjgVCyclAWUnkg0yauJYtPnnPitYI247m2V6'
const USER_KEY = '_pux'
const MERCHANT_KEY = '_pua'
const MERCHANT_SWITCHED_KEY = 'merchantSwitchedAt'

function generateRandomAlphanumeric(length: number) {
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let result = ''
  const charactersLength = characters.length
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

function encryptData(data: any) {
  return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString()
}

function decryptData(encrypted: string) {
  try {
    const bytes = CryptoJS.AES.decrypt(encrypted, SECRET_KEY)
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
  } catch {
    return null
  }
}

export function setMerchantCache(data: any) {
  const expireAt = Date.now() + 12 * 60 * 60 * 1000
  const payload = { data, expireAt }
  const encrypted = encryptData(payload)
  store.set(MERCHANT_KEY, encrypted)
}

export function getMerchantCache() {
  const encrypted = store.get(MERCHANT_KEY)
  if (!encrypted) return null

  const payload = decryptData(encrypted)
  if (!payload) return null

  if (payload.expireAt > Date.now()) {
    return payload.data
  }

  store.remove(MERCHANT_KEY)
  return null
}

export function clearMerchantCache() {
  store.remove(MERCHANT_KEY)
}

export function setUserCache(data: any) {
  const expireAt = Date.now() + 12 * 60 * 60 * 1000
  const payload = { data, expireAt }
  const encrypted = encryptData(payload)
  store.set(USER_KEY, encrypted)
}

export function getUserCache() {
  const encrypted = store.get(USER_KEY)
  if (!encrypted) return null

  const payload = decryptData(encrypted)
  if (!payload) return null

  if (payload.expireAt > Date.now()) {
    return payload.data
  }

  store.remove(USER_KEY)
  return null
}

export function clearUserCache() {
  store.remove(USER_KEY)
}

// ของที่ผูกกับร้าน — ล้างเมื่อเปลี่ยนร้าน/ล็อกอินใหม่ ไม่งั้นเห็นของร้านเดิม
// (last_product = สินค้าที่เลือกล่าสุดตอนเพิ่มลงออเดอร์ ถ้าค้างจะหยิบสินค้าร้านอื่นลงออเดอร์ได้)
export function clearMerchantScopedCache() {
  clearMerchantCache()
  clearUserCache()
  store.remove(LAST_PRODUCT_STORE)
}

// หลังบ้านจำร้านต่อบัญชี ไม่ใช่ต่อแท็บ — แท็บอื่นที่เปิดค้างยังโชว์ร้านเดิม
// แต่กดอะไรไปจะลงร้านใหม่ จึงบอกให้แท็บอื่นโหลดหน้าใหม่
export function notifyMerchantSwitched() {
  store.set(MERCHANT_SWITCHED_KEY, Date.now())
}

// event 'storage' ยิงเฉพาะแท็บอื่น ไม่ยิงในแท็บที่เปลี่ยนเอง
export function onMerchantSwitchedInOtherTab(callback: () => void) {
  const handler = (event: StorageEvent) => {
    if (event.key === MERCHANT_SWITCHED_KEY) {
      callback()
    }
  }
  window.addEventListener('storage', handler)
  return () => window.removeEventListener('storage', handler)
}
